import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../lib/select.jsx';
import { TextStylesList } from './TextAreaWithControls.constants.jsx';

type Props = {
  isDisabled: boolean;
  selectTextStyle?: (value: string) => void;
  readOnly?: boolean;
  setIsBlurBlocked: (value: boolean) => void;
  value?: string;
};

const TextStyleSelect = ({
  isDisabled,
  selectTextStyle,
  readOnly,
  setIsBlurBlocked,
  value,
}: Props) => {
  const handleChange = (value: string) => {
    selectTextStyle?.(value);
    setIsBlurBlocked(false);
  };

  return (
    <Select value={value} onValueChange={handleChange}>
      <SelectTrigger
        data-testid="test-select"
        disabled={isDisabled}
        readOnly={readOnly}
        size="small"
        className="w-[146px] max-w-[146px] min-w-[146px]"
        role="textStyleSelect"
        onPointerDown={() => {
          setIsBlurBlocked(true);
        }}
      >
        <SelectValue placeholder="Text Style" />
      </SelectTrigger>
      <SelectContent>
        {TextStylesList.map((style) => (
          <SelectItem
            key={style.value}
            className="cursor-pointer"
            value={style.value}
            startAdornment={style.startAdornment}
          >
            {style.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default TextStyleSelect;
